import Swiper from 'swiper';
import { Autoplay, EffectFade, EffectCube, EffectFlip, EffectCards, EffectCoverflow, Navigation, Pagination, Parallax, Scrollbar } from 'swiper/modules';
import Parvus from 'parvus';

const $ = jQuery;

sliderBlock($);

function sliderBlock($) {
	$('.sliderBlock').each(function (index) {
		const $this = $(this);
		const sliderId = $this.attr('data-slides-id');

		$this.find('.wp-block-cover').addClass('swiper-slide');

		const sliderClass = `sliderBlock_${index + 1}`;
		$this.addClass(sliderClass);

		let swiperOptions = {
			slidesPerView: parseInt($this.attr('data-slides-number'), 10),
			spaceBetween: parseInt($this.attr('data-slides-spazio'), 10),
			speed: parseInt($this.attr('data-slides-velocity'), 10),
			loop: $this.attr('data-slides-loop') === 'true',
			rewind: $this.attr('data-slides-rewind') === 'true',
			effect: $this.attr('data-slides-fade'),
			navigation: $this.attr('data-slides-freccie') === 'true' ? {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			} : false,
			pagination: $this.attr('data-slides-paginazione') === 'true' ? {
				el: '.swiper-pagination',
				clickable: true,
			} : false,
			scrollbar: $this.attr('data-slides-scrollbar') === 'true' ? {
				el: '.swiper-scrollbar',
				draggable: true,
			} : false,
			autoplay: $this.attr('data-slides-autoplay') === 'true' ? {
				delay: parseInt($this.attr('data-slides-time'), 10),
				disableOnInteraction: $this.attr('data-slides-interaction') === 'true',
				pauseOnMouseEnter: $this.attr('data-slides-hover') === 'true',
			} : false,
		};

		const customRules = $this.attr('data-extra-rules');
		if (customRules && customRules.trim() !== '') {
			let formattedCustomRules = customRules.trim();

			try {
				const openBraces = (formattedCustomRules.match(/{/g) || []).length;
				const closeBraces = (formattedCustomRules.match(/}/g) || []).length;

				if (openBraces > closeBraces) {
					formattedCustomRules += '}'.repeat(openBraces - closeBraces);
				}

				formattedCustomRules = formattedCustomRules
					.replace(/([a-zA-Z0-9_]+)\s*:/g, '"$1":')
					.replace(/:\s*'([^']*)'/g, ':"$1"')
					.replace(/:\s*([a-zA-Z_][a-zA-Z0-9_]*)(?=[,}\s])/g, ':"$1"')
					.replace(/,\s*}/g, '}')
					.replace(/,\s*]/g, ']')
					.replace(/,\s*$/, '');

				if (!formattedCustomRules.startsWith('{')) {
					formattedCustomRules = `{${formattedCustomRules}}`;
				}

				const parsedCustomRules = JSON.parse(formattedCustomRules);
				swiperOptions = { ...swiperOptions, ...parsedCustomRules };
			} catch (error) {
				console.error('Error parsing custom rules:', error);
				console.error('Original custom rules:', customRules);
				console.error('Formatted custom rules:', formattedCustomRules);
			}
		}

		if (typeof window.beforeSwiperInit === 'function') {
			window.beforeSwiperInit(swiperOptions, $this, sliderId);
		}

		swiperOptions.modules = [Autoplay, EffectFade, EffectCube, EffectFlip, EffectCards, EffectCoverflow, Navigation, Pagination, Parallax, Scrollbar];
		new Swiper(`.${sliderClass}`, swiperOptions);

		if ($this.attr('data-slides-lightbox') === 'true') {
			$this.find('.wp-block-cover:not(.swiper-slide-duplicate)').each(function () {
				const $cover = $(this);
				const urlImg = $cover.find('.wp-block-cover__image-background').attr('src');
				$cover.prepend(`<a href="${urlImg}" class="lightbox sliderBlock_lightbox_link" data-group="gallery_${index + 1}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index:1"></a>`);
			});

			new Parvus();
		}
	});
}
